import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './mobile.css';
import App from './App';
import ErrorBoundary from './components/Common/ErrorBoundary';
import indexedDB from './services/indexedDB';

// Initialize IndexedDB (non-blocking - don't prevent app from loading if it fails)
try {
  if (typeof indexedDB !== 'undefined' && indexedDB.init) {
    indexedDB.init()
      .then(() => {
        console.log('✅ IndexedDB initialized successfully');
      })
      .catch((error) => {
        console.error('❌ Failed to initialize IndexedDB:', error);
        // Don't block app loading - IndexedDB is for offline support only
      });
  }
} catch (error) {
  console.error('Error initializing IndexedDB:', error);
  // Continue - IndexedDB is optional
}

// Register Service Worker for PWA (only in production or when explicitly enabled)
// Disable service worker in development to prevent refresh loops
const isDevelopment = process.env.NODE_ENV === 'development';

// In development, always unregister service workers to prevent refresh loops
if (isDevelopment && typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister().then((success) => {
          if (success) {
            console.log('Service Worker unregistered for development');
          }
        }).catch((err) => {
          console.error('Error unregistering service worker:', err);
        });
      }
    }).catch((err) => {
      console.error('Error getting service worker registrations:', err);
    });
    // Clear all caches in development
    if (typeof window !== 'undefined' && 'caches' in window) {
      caches.keys().then((cacheNames) => {
        return Promise.all(
          cacheNames.map((cacheName) => {
            console.log('Deleting cache:', cacheName);
            return caches.delete(cacheName);
          })
        );
      }).catch((err) => {
        console.error('Error clearing caches:', err);
      });
    }
  } catch (error) {
    console.error('Error in service worker cleanup:', error);
  }
}

// Only register service worker in production
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator && !isDevelopment) {
  if (typeof window !== 'undefined') {
    window.addEventListener('load', () => {
      try {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('Service Worker registered:', registration);
            
            // Check for updates periodically
            registration.addEventListener('updatefound', () => {
              const newWorker = registration.installing;
              if (newWorker) {
                newWorker.addEventListener('statechange', () => {
                  if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    // New service worker available, but don't auto-reload
                    console.log('New service worker available. Reload page to update.');
                  }
                });
              }
            });
          })
          .catch((error) => {
            console.log('Service Worker registration failed:', error);
          });
      } catch (error) {
        console.error('Error registering service worker:', error);
      }
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
